import React, {useState} from 'react';
import RecommendedItem from "./RecommendedItem";

const RawPanel = (props) => {
    const [selectedTab, setSelectedTab] = useState("All items");

    const changeTab = (event) => {
        setSelectedTab(event.currentTarget.dataset.id);
    };

        const totalResult = props.results ? props.results.length : 0;
        const time = props.time ? `took: ${props.time}ms` : "";

        return (
            <div className="raw-panel">
                <div className="gui-editor-setup">
                    <div className="gui-editor-header">
                        <div className="simple-navigation">
                    <span data-id="All items" onClick={changeTab}
                          className={selectedTab === "All items" ? "navigation-tab current" : "navigation-tab"}>Recommended items</span>
                            <span data-id="Raw" onClick={changeTab}
                                  className={selectedTab === "Raw" ? "navigation-tab current" : "navigation-tab"}>Raw</span>
                            <span className="navigation-tab">Total result: {totalResult} {time} </span>
                        </div>
                    </div>
                    <div className={selectedTab === "Raw" ? "gui-editor-content active" : "gui-editor-content"}>
                    <pre className="json-results">{props.raw ? (JSON.stringify(props.raw, null, 2))
                    : (<h4 className="empty-result">{"Please make request to find some result."}</h4>)}</pre>
                </div>
                <div className={selectedTab === "All items" ? "gui-editor-content active" : "gui-editor-content"}>
                    <div className="results">
                        <div className="results__list">
                            {props.results.length > 0 ? (
                                props.results.slice(0, 1000).map((item, index) => <RecommendedItem title={item.title}
                                                                                    images={item.nameValues.find((field) => field.name === "imageUrl")}
                                                                                    allInformation={item.nameValues}
                                                                                    itemId={item.itemId}
                                                                                    order={index + 1}
                                                                                    key={item.itemId}/>)
                            ) : (
                                props.isRequested ? (<h4 className="empty-result">{"No items were in recommendation response"}</h4>)
                                : (<h4 className="empty-result">{"Please make request to find some result."}</h4>)

                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RawPanel;
